module.exports = __webpack_public_path__ + "img/syl_thumbnail.ae204331.jpg";